<div class="comunicado-container">
  <app-loading [exibir]="carregando"></app-loading>
  
  <!-- Header -->
  <div class="comunicado-header">
    <div class="header-content">
      <h1 class="page-title">
        <i class="fas fa-envelope"></i>
        <span translate>{{'comunicado.titulo'}}</span>
      </h1>
      <div class="header-actions">
        <button *ngIf="fabrica" class="btn btn-primary btn-new" (click)="novoComunicado()" (click)="ativaComunicado = false">
          <i class="fas fa-plus"></i>
          <span translate>{{'comunicado.novo'}}</span>
        </button>
        <!-- <a class="btn btn-outline-secondary btn-help" href="http://ajuda.nbsi.com.br:84/" target="_blank">
          <i class="fas fa-question-circle"></i>
          <span translate>{{'comunicado.ajuda'}}</span>
        </a> -->
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="comunicado-layout">
    <!-- Comunicado List Sidebar -->
    <div class="comunicado-sidebar" *ngIf="ativaComunicado">
      <div class="sidebar-header">
        <div class="sidebar-title">
          <div class="search-container">
            <div class="search-input-wrapper">
              <i class="fas fa-search search-icon"></i>
              <input 
                type="text" 
                class="search-input" 
                [class.has-filters]="temFiltrosAplicados()"
                [(ngModel)]="termoPesquisa"
                (input)="pesquisarComunicados()"
                [placeholder]="'comunicado.pesquisar.placeholder' | translate"
                [disabled]="carregando">
              <div class="btn-filter-wrapper">
                <button class="btn-filter" 
                        [class.filter-active]="temFiltrosAplicados()"
                        (click)="abrirModalFiltros()" 
                        [title]="'comunicado.pesquisar.filtros' | translate" 
                        [disabled]="carregando">
                  <i class="fas fa-filter"></i>
                  <span class="filter-badge" *ngIf="temFiltrosAplicados()"></span>
                </button>
                <button class="btn-clear-filter" 
                        *ngIf="temFiltrosAplicados()"
                        (click)="limparFiltrosRapido($event)"
                        [title]="'comunicado.filtros.limpar' | translate"
                        [disabled]="carregando">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div class="search-actions">
              <!-- <button class="btn btn-outline-secondary btn-clear" (click)="limparPesquisa()" [title]="'comunicado.pesquisar.limpar' | translate" [disabled]="!termoPesquisa || carregando">
                <i class="fas fa-times"></i>
              </button> -->
              <button class="btn btn-outline-secondary btn-refresh" (click)="refreshComunicados()" [title]="'comunicado.lista.atualizarLista' | translate" [disabled]="carregando">
                <i class="fas fa-sync-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="comunicado-list-container" #emailListContainer>
        <app-lista 
          [comunicados]="comunicadosParaExibir" 
          [carregandoComunicado]="carregandoComunicado"
          [comunicadoSelecionadoId]="selecionado?.id"
          (selecionado)="exibir($event)" 
          (marcarComoLido)="marcarComoLido($event)">
        </app-lista>
      </div>
      
      <!-- Pagination -->
      <div class="comunicado-pagination">
        <div class="pagination-compact">
          <!-- Configuração de Itens (Dropdown Discreto) -->
          <div class="items-config-wrapper">
            <button class="btn-config" 
                    (click)="toggleItensPorPaginaDropdown()" 
                    [title]="'comunicado.paginacao.itensPorPagina' | translate">
              <i class="fas fa-list-ul"></i>
              <span class="config-value">{{itensPorPagina}}</span>
            </button>
            
            <!-- Dropdown de Opções -->
            <div class="items-dropdown" *ngIf="mostrarDropdownItens">
              <div class="dropdown-header" translate>{{'comunicado.paginacao.itensPorPagina'}}</div>
              <button *ngFor="let opcao of opcoesItensPorPagina" 
                      class="dropdown-item"
                      [class.active]="opcao === itensPorPagina"
                      (click)="alterarItensPorPagina(opcao)">
                {{opcao}} itens
              </button>
            </div>
          </div>
          
          <!-- Navegação de Páginas -->
          <div class="pagination-nav">
            <button class="btn-pagination" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <span class="pagination-info">
              {{paginaAtual}} {{'comunicado.de' | translate}} {{totalPaginasAtual}}
            </span>
            <button class="btn-pagination" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual >= totalPaginasAtual">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <!-- Total de Registros -->
          <div class="total-records-compact">
            <span class="total-records-text">
              {{'comunicado.paginacao.total' | translate}}: {{totalRegistrosAtual}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Comunicado Content Area -->
    <div class="comunicado-content">
      <app-novo [ativo]="getEstado()" (salvado)="setEstado($event)" (ativaComunicado)="setEstadoComunicado($event)"></app-novo>
      <app-exibir [comunicado]="selecionado" [carregando]="carregandoComunicado" [fabrica]="fabrica" (marcarComoNaoLido)="marcarComoNaoLido($event)"></app-exibir>
    </div>
  </div>

  <!-- Dialog de Filtros -->
  <p-dialog header="{{ 'comunicado.filtros.titulo' | translate }}" [(visible)]="mostrarModalFiltros" [style]="{width: '550px'}" [modal]="true"
    [draggable]="false">
    <form>
      <div class="striped-rows">
        <!-- Filtro por Data Início -->
        <div class="row mb-3">
          <div translate class="col col-4">
            {{ 'comunicado.filtros.dataInicio' }}
          </div>
          <div class="col col-8">
            <p-calendar 
              [(ngModel)]="filtros.dataInicio"
              dateFormat="dd/mm/yy" 
              [showIcon]="true" 
              icon="pi pi-calendar"
              styleClass="p-inputtext-sm" 
              [style]="{'width':'100%'}" 
              [yearNavigator]="true"
              [monthNavigator]="true" 
              placeholder="{{ 'comunicado.filtros.dataInicio' | translate }}"
              showButtonBar="true"
              appendTo="body"
              name="dataInicio">
            </p-calendar>
          </div>
        </div>

        <!-- Filtro por Data Fim -->
        <div class="row mb-3">
          <div translate class="col col-4">
            {{ 'comunicado.filtros.dataFim' }}
          </div>
          <div class="col col-8">
            <p-calendar 
              [(ngModel)]="filtros.dataFim"
              dateFormat="dd/mm/yy" 
              [showIcon]="true" 
              icon="pi pi-calendar"
              styleClass="p-inputtext-sm" 
              [style]="{'width':'100%'}" 
              [yearNavigator]="true"
              [monthNavigator]="true" 
              placeholder="{{ 'comunicado.filtros.dataFim' | translate }}"
              showButtonBar="true"
              appendTo="body"
              name="dataFim">
            </p-calendar>
          </div>
        </div>

        <!-- Filtro por Tipo de Envio -->
        <div class="row mb-3">
          <div translate class="col col-4">
            {{ 'comunicado.filtros.tipoEnvio' }}
          </div>
          <div class="col col-8">
            <p-dropdown 
              [(ngModel)]="filtros.tipoEnvio"
              [options]="opcoesTipoEnvio"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'comunicado.filtros.todosTipos' | translate"
              [autoDisplayFirst]="false"
              [style]="{'width':'100%'}" 
              styleClass="p-inputtext-sm"
              appendTo="body"
              name="tipoEnvio">
            </p-dropdown>
          </div>
        </div>

        <!-- Filtro por Assunto -->
        <div class="row mb-3">
          <div translate class="col col-4">
            {{ 'comunicado.filtros.assunto' }}
          </div>
          <div class="col col-8">
            <input 
              type="text" 
              pInputText
              [(ngModel)]="filtros.assunto"
              [placeholder]="'comunicado.filtros.assuntoPlaceholder' | translate"
              name="assunto"
              styleClass="p-inputtext-sm"
              [style]="{'width':'100%'}">
          </div>
        </div>

        <!-- Filtro por Remetente -->
        <div class="row mb-3">
          <div translate class="col col-4">
            {{ 'comunicado.filtros.remetente' }}
          </div>
          <div class="col col-8">
            <input 
              type="text" 
              pInputText
              [(ngModel)]="filtros.remetente"
              [placeholder]="'comunicado.filtros.remetentePlaceholder' | translate"
              name="remetente"
              styleClass="p-inputtext-sm"
              [style]="{'width':'100%'}">
          </div>
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
        <i class="fa fa-trash" aria-hidden="true"></i>
        {{ 'comunicado.filtros.limpar' | translate }}
      </button>
      <button translate type="button" class="btn btn-info" (click)="aplicarFiltros()">
        {{ 'comunicado.filtros.aplicar' | translate }}
      </button>
    </ng-template>
  </p-dialog>
</div>